import r from "../managers/braze-instance.js";
import HtmlMessage from "./models/html-message.js";
import je from "./in-app-message-manager-factory.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageHtmlClick(e, t, s) {
  if (!r.rr()) return !1;
  if (!(e instanceof HtmlMessage))
    return (
      E.error(
        "inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object.",
      ),
      !1
    );
  let o = f.zn;
  null != t && (o = f.Sn);
  const m = je.ra().lt(e, o, t, s);
  if (m.W)
    for (let r = 0; r < m.Ee.length; r++)
      rt.o().he(ot.rm, [e.triggerId, t], m.Ee[r]);
  return m.W;
}
